module.exports = __webpack_public_path__ + "img/MFC8600.9232607b.png";